import $ from 'jquery';
/**
 * Enables the "news article" page functionality.
 */
const enableNewsArticleFunctionality = () => {
    if ($('#news-article').length === 0) {
        return;
    }
    $('#news-article .social-icons .icon-button').each(function () {
        const $button = $(this);
        const currentUrl = window.encodeURIComponent(window.location.toString());
        const title = window.encodeURIComponent(document.title.substr(0, 140));
        if ($button.hasClass('facebook-button')) {
            $button.on('click', () => {
                window.open(`https://www.facebook.com/sharer.php?u=${currentUrl}`, 'sharer', 'toolbar=0,status=0,width=580,height=325');
            });
        }
        else if ($button.hasClass('linkedin-button')) {
            $button.on('click', () => {
                window.open(`https://www.linkedin.com/shareArticle?url=${currentUrl}&title=${title}&mini=true`, 'sharer', 'toolbar=0,status=0,width=620,height=680');
            });
        }
        else if ($button.hasClass('twitter-button')) {
            $button.on('click', () => {
                window.open(`https://twitter.com/intent/tweet?url=${currentUrl}&text=${title}`, 'sharer', 'toolbar=0,status=0,width=620,height=390');
            });
        }
    });
};
export default enableNewsArticleFunctionality;
